import {
  GOT_CUSTOMER_RECENT_NOTES,
  UPDATE_IS_CUSTOMER_NOTE_EDITOR_OPEN,
  UPDATE_NEW_CUSTOMER_NOTE,
  SAVED_NEW_CUSTOMER_NOTE,
  DELETED_CUSTOMER_NOTE,
  UPDATE_EDITING_NOTE,
  SAVED_EDIT_CUSTOMER_NOTE,
  UPDATE_EXPANDED_NOTE_ID,
  SET_IS_LOADING_CUSTOMER_NOTES,
  CLEAR_CUSTOMER_NOTE_API_ERROR
} from "../actions/customerNotes";
import { UPDATED_GLOBAL_ERROR_MESSAGE } from "../actions/globalError";

import { customerNotesInitialState } from "../state/initialState";
import { clone } from "./helper";
import objectAssign from "object-assign";
import moment from "moment";
export default (state = customerNotesInitialState, action) => {
  let newStatus;
  switch (action.type) {
    case GOT_CUSTOMER_RECENT_NOTES: {
      if (action.data.status === "failed") {
        // TODO: display the stored error
        return objectAssign({}, state, {
          apiErrorReasons: action.data.reasons,
          loadingCustomerNotes: false
        });
      } else {
        action.data.sort(
          (note1, note2) => moment(note2.created) - moment(note1.created)
        );
        return objectAssign({}, state, {
          customerRecentNotes: action.data,
          loadingCustomerNotes: false
        });
      }
    }
    case UPDATE_IS_CUSTOMER_NOTE_EDITOR_OPEN:
      return objectAssign({}, state, {
        isCustomerNoteEditorOpen: action.data.isOpen
      });
    case UPDATE_NEW_CUSTOMER_NOTE:
      return objectAssign({}, state, { newCustomerNote: action.data.newNote });
    case SAVED_NEW_CUSTOMER_NOTE:
      if (action.data.status === "failed") {
        // TODO: display the stored error
        return objectAssign({}, state, {
          apiErrorReasons: action.data.reasons,
          loadingCustomerNotes: false
        });
      } else {
        let newNotesArray = clone(state.customerRecentNotes);
        newNotesArray.unshift(action.data);
        return objectAssign({}, state, {
          customerRecentNotes: newNotesArray,
          newCustomerNote: "",
          isCustomerNoteEditorOpen: false,
          loadingCustomerNotes: false
        });
      }
    case DELETED_CUSTOMER_NOTE: {
      if (action.data.status === "failed") {
        // TODO: display the stored error
        return objectAssign({}, state, {
          apiErrorReasons: action.data.reasons,
          loadingCustomerNotes: false
        });
      } else {
        const tempNotesArray = clone(state.customerRecentNotes);
        const newNotesArray = tempNotesArray.filter(
          note => note.id !== action.data.noteId
        );
        return objectAssign({}, state, {
          customerRecentNotes: newNotesArray,
          loadingCustomerNotes: false
        });
      }
    }
    case UPDATE_EDITING_NOTE: {
      return objectAssign({}, state, {
        newCustomerNote: action.data.noteContent,
        editingNoteId: action.data.noteId
      });
    }
    case SAVED_EDIT_CUSTOMER_NOTE: {
      if (action.data.status === "failed") {
        // TODO: display the stored error
        return objectAssign({}, state, {
          apiErrorReasons: action.data.reasons,
          loadingCustomerNotes: false
        });
      } else {
        const noteId = action.data.id;
        let newNotesArray = clone(state.customerRecentNotes);
        let index = -1;
        for (let counter = 0; counter < newNotesArray.length; counter++) {
          if (newNotesArray[counter].id === noteId) {
            index = counter;
          }
        }
        if (index > -1) {
          newNotesArray[index] = action.data;
        }
        return objectAssign({}, state, {
          customerRecentNotes: newNotesArray,
          newCustomerNote: "",
          isCustomerNoteEditorOpen: false,
          editingNoteId: null,
          loadingCustomerNotes: false
        });
      }
    }
    case UPDATE_EXPANDED_NOTE_ID:
      return objectAssign({}, state, { expandedNoteId: action.data.noteId });
    case UPDATED_GLOBAL_ERROR_MESSAGE:
      newStatus = {
        loadingCustomerNotes: false
      };
      return objectAssign({}, state, newStatus);
    case SET_IS_LOADING_CUSTOMER_NOTES:
      return objectAssign({}, state, {
        loadingCustomerNotes: action.data.loadingCustomerNotes
      });
    case CLEAR_CUSTOMER_NOTE_API_ERROR:
      return objectAssign({}, state, { apiErrorReasons: null });
    default:
      return state;
  }
  return state;
};
